import {defineStore, mapActions} from 'pinia';
import AdminService from "../services/AdminService";
import CommonServices from "../services/CommonServices";


export const useAdminStore = defineStore('AdminStore', {
    state: () => {
        return {
            categories: [],
            companies: [],
            artists: [],
            statuses: [],
            clientStatuses: [],
            subcategories: [],
            listOfUsers: [],
            clients: [],
            roles: [],
            currentUser: null,
        }
    },


    actions: {
       async fetchListOfCategories() {
           try {
               const { data: response } = await AdminService.getListOfCategories()
               this.categories = response
           } catch {
            console.error()
           }
       },
        async fetchListOfCompanies() {
            try {
                const { data: response } = await AdminService.getListOfCompanies()
                this.companies = response
            } catch {
                console.error()
            }
        },

        async fetchListOfArtists(filters) {
            try {
                const { data: response } = await AdminService.getListOfArtists(filters)
                this.artists = response
            } catch {
                console.error()
            }
        },

        async fetchListOfStatuses() {
            try {
                const { data: response } = await CommonServices.getListOfStatuses()
                this.statuses = response
            } catch {
                console.error()
            }
        },

        async fetchListOfClientStatuses() {
            try {
                const { data: response } = await CommonServices.getListOfClientStatuses()
                this.clientStatuses = response
            } catch {
                console.error()
            }
        },

        async fetchListOfSubcategories() {
           try {
               const { data: response } = await AdminService.getSubcategoriesForSelect()
               this.subcategories = response
           } catch (e) {
               console.error(e)
           }
        },
        async fetchListOfUsers() {
            try {
                const { data: response } = await AdminService.getUsersList()
                this.listOfUsers = response
            } catch (e) {
                console.error(e)
            }
        },

        async fetchListOfRoles() {
            try {
                const { data: response } = await AdminService.getRolesList()
                this.roles = response
            } catch (e) {
                console.error(e)
            }
        },
        async fetchListOfClients(filters) {
            try {
                const { data: response } = await AdminService.getClientsList(filters)
                this.clients = response
            } catch (e) {
                console.error(e)
            }
        },
    },
})
